import { postWithAuth } from '@/lib/httpAdapter';
import SyncedGitRequestType from '@/types/syncedGitRequestType';
import apiUrl from './api';
import headerObject from '@/types/headerObj';

const localHost = apiUrl;
const endPoint = 'syncedGitSource/';
const url = localHost + endPoint;

const syncedGitSource = async (
  req: SyncedGitRequestType,
  headerObj?: headerObject
) => {
  try {
    const response = await postWithAuth(
      url,
      {
        OrgUUID: req.OrgUUID,
      },
      {
        headers: {
          ...headerObj,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    if (typeof data === 'string') {
      return JSON.parse(data);
    }
    if (data?.Error) {
      throw new Error(data?.Error);
    }
    return data.SprintList;
  } catch (err) {
    console.error(err);
  }
};

export default syncedGitSource;
